define.alias("shared/components/shared/loading-cards", "settings/components/shared/loading-cards");